import BaseGrid from "../sections/view";
import { text } from "../../helpers/templates";
import { checkedIconAlt, notCheckedIconAlt } from "../../helpers/icons";

export default class MatrixView extends BaseGrid {
	config() {
		const ui = super.config();
		this.Sorting = { column: "", dir: "" };

		webix.extend(
			ui,
			{
				css: "webix_um_matrix",
				rowHeight: 56,
				headerRowHeight: 56,
				leftSplit: 1,
				select: false,
				on: {
					onItemClick: id => this.Toggle(id),
					// to sort descendant by default
					onHeaderClick: header => this.ToggleColumnSorting(header.column),
				},
			},
			true
		);

		return this.GetRoleColumns().then(roles => {
			ui.columns = [
				{
					id: "name",
					header: "",
					width: 220,
					css: "webix_um_column_name",
					sort: "string",
					template: text(this),
				},
				...roles,
			];

			return ui;
		});
	}

	init() {
		return this.GetData();
	}

	GetData() {
		const local = this.app.getService("local");
		return Promise.all([local.roles(), local.users()]).then(res => {
			const data = this.CreateMatrix(res[0], res[1]);
			this.InitSelf(data);
		});
	}

	SearchCompare(value, user) {
		return user.name.toLowerCase().indexOf(value) > -1;
	}

	Save(id) {
		let user = this.app
			.getService("local")
			.users(true)
			.getItem(id);
		const gridUser = this.$$("table").getItem(id);
		user.roles = [];
		const roles = this.app.getService("local").roles(true);
		roles.data.each(role => {
			if (gridUser[role.id]) user.roles.push(role.id);
		});
		this.app.getService("operations").updateUser(id, user);
	}

	Toggle(id) {
		let item = this.$$("table").getItem(id);
		const column = id.column;
		if (column != "name") {
			item[column] = !item[column];
			item.selected = !item.selected;
			this.$$("table").updateItem(id, item);
			this.Save(id);
		}
	}

	GetRoleColumns() {
		return this.app
			.getService("local")
			.roles()
			.then(roles => {
				const columns = [];
				roles.data.each(role => {
					columns.push({
						id: role.id,
						header: {
							text: `<span>${role.name}</span>`,
							css: "webix_um_center_column webix_um_names",
						},
						minWidth: 100,
						fillspace: 1,
						css: "webix_um_center_column",
						template: obj => {
							return obj[role.id] ? checkedIconAlt : notCheckedIconAlt;
						},
					});
				});

				return columns;
			});
	}

	CreateMatrix(rolesData, users) {
		let index = 0;
		const data = users.serialize().map(({ id, name, roles }) => {
			let roleAssigned = {};
			rolesData.data.each(role => {
				roleAssigned[role.id] = roles ? roles.indexOf(role.id) > -1 : false;
			});
			return { id, name, $index: index++, ...roleAssigned };
		});
		return data;
	}

	ToggleColumnSorting(column) {
		if (column != "name") {
			let dir =
				this.Sorting.column == column && this.Sorting.dir == "desc"
					? "asc"
					: "desc";
			this.$$("table").sort({ by: column, dir: dir, as: "string" });
			this.$$("table").markSorting(column, dir);
			this.Sorting.dir = dir;
		}
		this.Sorting.column = column;
	}
}
